/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const areon_chain_about = () => `Areon Chain is a revolutionary Layer-1 blockchain that sets new standards in the crypto world with its groundbreaking speed and security. Utilizing the unique "Proof of AREA" algorithm, Areon Chain successfully merges security and speed. Within the system, validator and delegator mechanisms exist, encouraging wider community participation and enhancing the overall robustness of the network.`
